import React from 'react';
import { Card, CardContent } from '../ui/card';
import { getServiceIcon } from '../../lib/serviceIcons';

const MainServiceCard = ({ service, index, image }) => {
  const IconComponent = getServiceIcon(service.icon);
  const isReversed = index % 2 === 1;

  return (
    <Card className="border-2 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
        <div className={isReversed ? 'lg:order-2' : ''}>
          <img
            src={image}
            alt={service.title}
            className="w-full h-64 lg:h-full object-cover"
          />
        </div>
        <CardContent
          className={`p-8 lg:p-12 space-y-6 flex flex-col justify-center ${
            isReversed ? 'lg:order-1' : ''
          }`}
        >
          <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center">
            <IconComponent className="w-8 h-8 text-blue-600" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900">{service.title}</h2>
          <p className="text-lg text-gray-600 leading-relaxed">{service.description}</p>
          <p className="text-gray-700 leading-relaxed">{service.details}</p>
        </CardContent>
      </div>
    </Card>
  );
};

export default MainServiceCard;
